<template>
<footer class="footer">
  <div class="footer-header">
    <div class="footer-title acr-bold-22">{{title}}</div>
    <div style="display: flex;align-items: center">
      <slot name="options"></slot>
      <div class="footer-btn" :class="{'active': active}" @click="confirm"><span style="margin-top: -3px">{{actionBtnText}}</span></div>
      <div class="footer-btn close" v-if="showClose" @click="$emit('close')">
        <svgicon name="Close"></svgicon>
      </div>
    </div>
  </div>
  <slot></slot>
</footer>
</template>

<script>
export default {
  name: "BaseFooter",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: false
    },
    actionBtnText: {
      type: String,
      default: 'Add videos'
    },
    title: {
      type: String,
      default: 'Uploading videos'
    },
    onConfirm: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    confirm() {
      if (this.active) {
        this.onConfirm();
      }
    }
  },
}
</script>

<style scoped lang="scss">

</style>
